<template>
  <b-form-tags
    :value="value"
    class="m-0 p-0"
    @input="$emit('input', $event)"
    no-outer-focus
    style="border: none"
  >
    <template v-slot="{ tags, addTag, removeTag  }">
      <span class="tag-multiselect text-nowrap">
        <b-dropdown
          :disabled="availableOptions.length == 0"
          class="multiselect-dropdown mr-1"
          size="sm"
          variant="link"
          no-caret
        >
          <template v-slot:button-content>
            <b-icon icon="plus-circle" />
          </template>
          <b-dropdown-item-button
            size="sm"
            v-for="option in availableOptions"
            :key="option.value"
            @click="addTag(option.value)"
          >{{ option.text }}</b-dropdown-item-button>
        </b-dropdown>

        <ul v-if="tags.length > 0" class="list-inline d-inline-block m-0 text-nowrap">
          <li v-for="tag in tags" :key="tag" class="list-inline-item mx-0">
            <b-button-group class="visible-option mr-1" size="sm">
              <b-button
                :variant="optionForValue(tag).variant || 'secondary'"
                @click="optionForValue(tag).clickable ? onOptionClick(tag) : null"
              >{{ optionForValue(tag).text }}</b-button>
              <b-button
                v-if="optionForValue(tag).removable != false"
                :variant="optionForValue(tag).variant || 'secondary'"
                @click="removeTag(tag)"
              >
                <b-icon icon="x" />
              </b-button>
            </b-button-group>
            <!-- <b-form-tag
              :variant="optionForValue(tag).variant || 'secondary'"
              :class="{
                clickable: optionForValue(tag).clickable
              }"
              @remove="removeTag(tag)"
              @click.native="optionForValue(tag).clickable && $event.target ? onOptionClick(tag) : null"
              :title="optionForValue(tag).text"
              :disabled="optionForValue(tag).removable == false"
            ></b-form-tag>-->
          </li>
        </ul>
      </span>
    </template>
  </b-form-tags>
</template>
<script>
export default {
  props: {
    value: Array,
    options: Array,
  },
  computed: {
    availableOptions() {
      return this.options.filter((o) => !this.value.includes(o.value));
    },
  },
  methods: {
    optionForValue(value) {
      return this.options.find((o) => o.value == value);
    },
    onOptionClick(tag) {
      this.$emit("option-click", tag);
    },
  },
};
</script>
<style lang="scss">
.tag-multiselect {
  .multiselect-dropdown {
    button {
      display: flex;
      align-items: center;
    }

    .dropdown-menu {
      min-width: initial;
      padding: 0;
    }
  }

  .visible-option button {
    padding: 0.05rem 0.2rem;
  }
}
</style>